import { Grid, Space } from '@mantine/core';
import { PageTitle } from 'components/PageTitle';
import { i18nKeys, useTranslation } from 'locales';
import { AppearanceCard } from './Appearance';
import { InvoiceFooterCard } from './Footer';
import { InvoiceLogsCard } from './InvoiceLogs';
import { SendingMediumCard } from './SendingMedium';
import { SendingOptionsCard } from './SendingOptions';

export const InvoiceSettings = () => {
  const { t } = useTranslation();

  return (
    <>
      <PageTitle>{t(i18nKeys.SETTINGS.INVOICING.TITLE)}</PageTitle>
      <Grid mb="md" align="stretch">
        <Grid.Col span={6}>
          <AppearanceCard />
        </Grid.Col>
        <Grid.Col span={6}>
          <SendingOptionsCard />
        </Grid.Col>
        <Grid.Col span={6}>
          <SendingMediumCard />
        </Grid.Col>
        <Grid.Col span={6}>
          <InvoiceLogsCard />
        </Grid.Col>
        <Grid.Col span={12}>
          <InvoiceFooterCard />
          <Space h="md" />
        </Grid.Col>
      </Grid>
    </>
  );
};
